var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "new-google-drive-channel-form" } },
    [
      _c("a-form", [
        _c("div", { staticClass: "form-wrapper" }, [
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("googleDrive.channelName")))]),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: {
                    "validate-status": _vm.getErrorStatus("channelName"),
                    help: _vm.getErrorMessage("channelName"),
                  },
                },
                [
                  _c("a-input", {
                    ref: "channelName",
                    attrs: {
                      placeholder: _vm.$t("googleDrive.channelName"),
                      name: "channelName",
                    },
                    model: {
                      value: _vm.form.channelName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "channelName", $$v)
                      },
                      expression: "form.channelName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "oauth-credentials-section" },
            [
              _c("a-alert", {
                staticClass: "mb-3",
                attrs: { type: "info", "show-icon": "" },
                scopedSlots: _vm._u([
                  {
                    key: "message",
                    fn: function () {
                      return [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("googleDrive.byocTitle"))),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "description",
                    fn: function () {
                      return [
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("googleDrive.byocDescription"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "mt-2 d-block",
                            attrs: {
                              href: "https://console.cloud.google.com/apis/credentials",
                              target: "_blank",
                            },
                          },
                          [
                            _c(
                              "i",
                              {
                                staticClass: "material-icons",
                                staticStyle: {
                                  "font-size": "14px",
                                  "vertical-align": "middle",
                                },
                              },
                              [_vm._v("open_in_new")]
                            ),
                            _vm._v(
                              "\n                            Google Cloud Console\n                        "
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("googleDrive.clientId")) + " "),
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        "validate-status": _vm.getErrorStatus("clientId"),
                        help: _vm.getErrorMessage("clientId"),
                      },
                    },
                    [
                      _c("a-input", {
                        ref: "clientId",
                        attrs: {
                          placeholder: _vm.$t(
                            "googleDrive.clientIdPlaceholder"
                          ),
                          name: "clientId",
                        },
                        model: {
                          value: _vm.form.clientId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "clientId", $$v)
                          },
                          expression: "form.clientId",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-wrapper" },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("googleDrive.clientSecret")) + " "),
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        "validate-status": _vm.getErrorStatus("clientSecret"),
                        help: _vm.getErrorMessage("clientSecret"),
                      },
                    },
                    [
                      _c("a-input-password", {
                        ref: "clientSecret",
                        attrs: {
                          placeholder: _vm.$t(
                            "googleDrive.clientSecretPlaceholder"
                          ),
                          name: "clientSecret",
                        },
                        model: {
                          value: _vm.form.clientSecret,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "clientSecret", $$v)
                          },
                          expression: "form.clientSecret",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-collapse",
                { staticClass: "setup-guide" },
                [
                  _c(
                    "a-collapse-panel",
                    {
                      attrs: { header: _vm.$t("googleDrive.setupGuideTitle") },
                    },
                    [
                      _c("ol", { staticClass: "setup-steps" }, [
                        _c("li", [
                          _vm._v(_vm._s(_vm.$t("googleDrive.setupStep1"))),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(_vm._s(_vm.$t("googleDrive.setupStep2"))),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(_vm._s(_vm.$t("googleDrive.setupStep3"))),
                        ]),
                        _vm._v(" "),
                        _c(
                          "li",
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.$t("googleDrive.setupStep4")) +
                                "\n                                "
                            ),
                            _c("code", { staticClass: "redirect-uri" }, [
                              _vm._v(_vm._s(_vm.redirectUri)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: { size: "small", type: "link" },
                                on: { click: _vm.copyRedirectUri },
                              },
                              [
                                _c(
                                  "i",
                                  {
                                    staticClass: "material-icons",
                                    staticStyle: { "font-size": "14px" },
                                  },
                                  [_vm._v("content_copy")]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(_vm._s(_vm.$t("googleDrive.setupStep5"))),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _vm._v(_vm._s(_vm.$t("googleDrive.setupStep6"))),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "connect-body" }, [
            _c("div", { staticClass: "requirements" }, [
              _c("div", [
                _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
                _vm._v(_vm._s(_vm.$t("googleDrive.ensureGoogleAccount"))),
              ]),
              _vm._v(" "),
              _c("div", [
                _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
                _vm._v(_vm._s(_vm.$t("googleDrive.ensureGoogleDriveAccess"))),
              ]),
            ]),
            _vm._v(" "),
            _c("strong", [
              _vm._v(" " + _vm._s(_vm.$t("googleDrive.permissionDesc")) + " "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("a-checkbox", {
                  attrs: { checked: _vm.termOfService },
                  on: {
                    change: function ($event) {
                      return _vm.acceptTermOfService("pp")
                    },
                  },
                }),
                _vm._v(" "),
                _c("b", [
                  _vm._v(
                    _vm._s(_vm.$t("search.integration.readAndAgree")) +
                      "\n                        "
                  ),
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.acceptTermOfService("pp")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("search.integration.privatePolicy")))]
                  ),
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("message.and")) +
                      "\n                        "
                  ),
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.acceptTermOfService("tac")
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("search.integration.termsAndCondition"))
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "div",
          { staticClass: "actions" },
          [
            _c(
              "SupsisButton",
              { attrs: { ghost: "" }, on: { click: _vm.handleCancel } },
              [_vm._v(" " + _vm._s(_vm.$t("wp.cancel")))]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: {
                  primary: "",
                  disabled: !_vm.termOfService || _vm.loading,
                  loading: _vm.loading,
                },
                on: { click: _vm.handleSubmit },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("googleDrive.connectToGoogleDrive")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.termOfServiceModal
        ? _c("TermOfService", {
            attrs: { type: _vm.termOfServiceModal },
            on: {
              agree: _vm.acceptedTermOfService,
              cancel: function ($event) {
                _vm.termOfServiceModal = null
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }